// 官方文件建議編輯器最小高度
export const EMAIL_EDITOR_HEIGHT = 700
